import React, { useEffect, useState, useContext } from "react";
import { Helmet } from 'react-helmet';

import AOS from 'aos';
import 'aos/dist/aos.css';
import "./css/bootstrap.min.css";
import "./css/styles.css";
import "./css/fancybox.css";
import "./css/fsea.css";


import Container from '@mui/material/Container';
import Grid from "@mui/material/Grid";
import { NavMenu } from './NavMenu';
import FeedbackAlert from "../../Shared/FeedbackAlert";
import ConfigFerrettiInfynito from "../../Home/ConfigFerrettiInfynito";

import SeasonTerrace from "./SeasonTerrace";
import BeachClub from "./BeachClub";
import Flybridge from "./Flybridge";
import GalleryExt from "./GalleryExt";
import InteriorArea from "./InteriorArea";
import Guests from "./Guests";
import PilotHouse from "./PilotHouse";
import GalleryInt from "./GalleryInt";
import Videos from "./Videos";
import BoatAnatomy from "./BoatAnatomy";
import TechData from "./TechData";
import RequestForm from "../../Form/RequestForm";
import FooterFerrettiInfynito from "../../Home/FooterFerrettiInfynito";
import VideoIntro from "./VideoIntro";
import Intro from "./Intro";
import FseaSection from "./FseaSection";

export const LandingInfynito80 = (props) => {

    const [feedback, setFeedback] = useState({
        severity: "success",
        text: "Success",
        open: false,
    });

    const feedbackCallback = (severity, text, open) => {
        setFeedback({ severity: severity, text: text, open: open });
    };

    const alertClosed = () => {
        setFeedback({ ...feedback, open: false });
    };


    useEffect(() => {

        // Init scripts
        AOS.init();

    }, []);

    return (
        <Container maxWidth={false} disableGutters classes={{ root: 'Main-container' }}>
            <NavMenu modelCode={props.modelCode} cultureCode={props.cultureCode} />
            <VideoIntro modelCode={props.modelCode} cultureCode={props.cultureCode} />
            <Intro cultureCode={props.cultureCode} />
            <SeasonTerrace cultureCode={props.cultureCode} />
            <BeachClub cultureCode={props.cultureCode} />
            <Flybridge cultureCode={props.cultureCode} />
            <GalleryExt cultureCode={props.cultureCode} />
            <InteriorArea cultureCode={props.cultureCode} />
            <Guests cultureCode={props.cultureCode} />
            <PilotHouse cultureCode={props.cultureCode} />
            <GalleryInt cultureCode={props.cultureCode} />
            <ConfigFerrettiInfynito modelCode={props.modelCode} cultureCode={props.cultureCode} indexStep={-1} />
            <BoatAnatomy cultureCode={props.cultureCode} />
            <Videos cultureCode={props.cultureCode} />
            <FseaSection cultureCode={props.cultureCode} />
            <TechData cultureCode={props.cultureCode} />

            <div className="contaniner-fluid py-5" id="Contact-us">
                <div className="container py-5">
                    <div className="col-12">
                        <div className="valign">
                            <div className="align-middle d-table-cell">
                                <div className="d-table mx-auto">
                                    <h2 className="text-white text-uppercase mb-3 text-center">{props.cultureCode === "en-us" ? "Contact us" : "Contattaci"}</h2>
                                    <RequestForm modelCode={props.modelCode} withCustomization={false} feedbackCallback={feedbackCallback} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FooterFerrettiInfynito cultureCode={props.cultureCode} />

            <FeedbackAlert
                severity={feedback.severity}
                text={feedback.text}
                open={feedback.open}
                closedCallback={alertClosed}
            />

        </Container>
    );

};

export default LandingInfynito80;